// Lib
import { compose } from 'recompose';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import React, { memo } from 'react';

const styles = {
  container: {
    backgroundColor: '#f8f9fb',
    padding: '20px 32px',
  },
  errorMessage: {
    fontSize: '1rem',
  },
  closeButtonContainer: {
    marginTop: '10px',
    display: 'flex',
    justifyContent: 'right',
  },
  closeButton: {
    width: '40px',
  },
};

export const ErrorModal = ({ classes, errorMessage, onClose, open }) => (
  <Dialog open={open} classes={{ paper: classes.container }} onClose={onClose} fullWidth>
    <span className={classes.errorMessage}>{errorMessage}</span>
    <div className={classes.closeButtonContainer}>
      <Button onClick={onClose} variant="contained" color="primary" className={classes.closeButton}>
        <FormattedMessage id="Ok" />
      </Button>
    </div>
  </Dialog>
);

ErrorModal.displayName = 'ErrorModal';

export default compose(
  withStyles(styles),
  memo
)(ErrorModal);



// WEBPACK FOOTER //
// ./src/Shared/Modals/ErrorModal.js